import {IconNames} from '../../../components/UI/Icon/types'
import {categories} from '../constants/categories'

import {advisorApprovalStatusMap} from '@/src/shared/constants/statusMaps'

interface MenuContent {
  href: string
  text: string
}

export const generateMegaMenuItems = () => {
  const megaMenuContent: {[key: string]: Array<Array<MenuContent>>} = {}
  const parents = categories.filter(cat => Number(cat.level) === 1)

  parents.forEach(({id}) => {
    const categoryContent: Array<Array<MenuContent>> = []
    const level2Categories = categories.filter(cat => cat.parentId === id)
    level2Categories.forEach(({id, title}) => {
      const contentColumn: Array<MenuContent> = [{href: '/', text: title}]
      const level3Categories = categories.filter(cat => cat.parentId === id)
      level3Categories.forEach(({slug, title}) => {
        contentColumn.push({href: slug, text: title})
      })
      categoryContent.push(contentColumn)
    })
    megaMenuContent[id] = categoryContent
  })
  return megaMenuContent
}

interface Dropdown {
  dropdown?: Array<Dropdown>
  href: string
  title: string
}

export interface CollapseMenuContent {
  dropdown?: Array<Dropdown>
  href: string
  icon: IconNames
  title: string
}

export const generateCollapseMenuItems = (
  status: keyof typeof advisorApprovalStatusMap
) => {
  const collapseMenuContent: CollapseMenuContent[] = []
  const parents = categories.filter(cat => Number(cat.level) === 1)
  const icons: IconNames[] = ['heart', 'pregnantWoman', 'suitcase']
  parents.forEach((cat, index) => {
    const newCat = {...cat, icon: icons[index] as IconNames}
    return newCat
  })

  parents.forEach((parent, index) => {
    const level2Categories = categories.filter(
      cat => cat.parentId === parent.id
    )
    const level2dropdown: Dropdown[] = []

    level2Categories.forEach(level2Category => {
      const level3Categories = categories.filter(
        cat => level2Category.id === cat.parentId
      )
      const dropdown: Dropdown[] = []

      level3Categories.forEach(level3Category => {
        dropdown.push({
          href: level3Category.slug,
          title: level3Category.title,
        })
      })
      level2dropdown.push({
        dropdown,
        href: '/',
        title: level2Category.title,
      })
    })
    collapseMenuContent.push({
      dropdown: level2dropdown,
      href: '/',
      icon: icons[index],
      title: parent.title,
    })
  })
  collapseMenuContent.unshift({href: '/', icon: 'home', title: 'Anasayfa'})
  collapseMenuContent.push(
    {href: '/blog?sayfa=1', icon: 'pencil', title: 'Blog'},
    {href: '/rehber?sayfa=1', icon: 'guide', title: 'Rehber'},
    {href: '/nasil-calisiyor', icon: 'question', title: 'Nasıl Çalışıyor'}
  )
  if (status === 'CREATED' || !status) {
    collapseMenuContent.push({
      href:
        status === 'CREATED' ? '/danisman-kaydi/adim1' : '/danisman/kayit-ol',
      icon: 'personAdd',
      title: status === 'CREATED' ? 'BAŞVURUYA DEVAM ET' : 'DANIŞMAN OL',
    })
  }

  return collapseMenuContent
}
